import { type Route } from './+types/support.ts'

export const meta: Route.MetaFunction = () => [{ title: 'Support | Podly' }]

const faqs = [
	{
		question: 'How does the free plan work?',
		answer:
			'You can upload, trim, and clean up audio for free, and export your first finished episode at no cost. After that, Pro unlocks unlimited exports and a dashboard for all your files.',
	},
	{
		question: 'What happens to my files if I don’t subscribe?',
		answer:
			'Files that sit inactive for a couple of days on the free plan are automatically cleaned up to keep storage costs down. We email a warning before anything is removed.',
	},
	{
		question: 'Can I cancel anytime?',
		answer:
			'Yes — manage or cancel your subscription anytime from your dashboard. You keep access through the end of the period you’ve already paid for.',
	},
]

export default function SupportRoute() {
	return (
		<main className="text-base-content font-poppins flex min-h-screen flex-col bg-gradient-to-b from-background via-indigo-500/5 to-purple-500/10">
			<section className="mx-auto w-full max-w-3xl px-6 py-24">
				<h1 className="mb-4 text-center text-5xl font-extrabold tracking-tight text-foreground md:text-6xl">
					Support
				</h1>
				<p className="text-base-content/80 mx-auto mb-16 max-w-xl text-center text-xl">
					Answers to common questions about using Podly.
				</p>
				<div className="flex flex-col gap-6">
					{faqs.map((faq) => (
						<div
							key={faq.question}
							className="border-foreground/20 bg-background/50 rounded-2xl border p-6 backdrop-blur-sm md:p-8"
						>
							<h2 className="mb-2 text-xl font-bold text-foreground">
								{faq.question}
							</h2>
							<p className="text-base-content/80">{faq.answer}</p>
						</div>
					))}
				</div>
			</section>
		</main>
	)
}
